import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import TogglerBody from '../../TogglerBody';
import {RxCross1} from 'react-icons/rx';
import TipsTamplate from '../../TipsTamplate';
import './notificationTamplateBlock.scss';
import {useChanges} from '../../../../hooks/useChanges';
import SearchDropdownBtn from '../../SearchDropdown/SearchDropdownBtn';
import SearchDropdown from '../../SearchDropdown/SearchDropdow';

const NotificationTamplateBlock = ({data}) => {
  const {addChangeToStore} = useChanges();
  const {membersGlobalState} = useSelector((state) => state.members);
  const {channelsGlobalState} = useSelector((state) => state.channels);

  const [showBtnUser, setShowBtnUser] = useState(true);
  const [inputValueDMUser, setInputValueDMUser] = useState('');
  const [dmUser, setDMUsers] = useState(data?.dmUser || []);
  const [showBtnChannel, setShowBtnChannel] = useState(true);
  const [inputValueChannels, setInputValueChannels] = useState('');
  const [channels, setChannels] = useState(data?.logChannels || []);

  const [isAlerts, setIsAlerts] = useState(data?.sendLogs || false);
  const [lLevel, setLLevel] = useState(data?.lLevel || false);
  const [mLevel, setMLevel] = useState(data?.mLevel || false);
  const [hLevel, setHLevel] = useState(data?.hLevel || false);
  const [discordLogs, setDiscordLogs] = useState(data?.discordLogs || false);
  const [emailLogs, setEmailLogs] = useState(data?.emailLogs || false);
  const [inputValue, setInputValue] = useState('');
  const [inputValueUser, setInputValueUser] = useState('');

  const handleCheckboxChange = (e) => {
    const {name, checked} = e.target;
    switch (name) {
      case 'lLevel':
        addChangeToStore({key: 'lLevel', value: checked});
        setLLevel(checked);
        break;
      case 'mLevel':
        addChangeToStore({key: 'mLevel', value: checked});
        setMLevel(checked);
        break;
      case 'hLevel':
        addChangeToStore({key: 'hLevel', value: checked});
        setHLevel(checked);
        break;
      case 'discordLogs':
        addChangeToStore({key: 'discordLogs', value: checked});
        setDiscordLogs(checked);
        break;
      case 'emailLogs':
        addChangeToStore({key: 'emailLogs', value: checked});
        setEmailLogs(checked);

      default:
        break;
    }
  };

  const addDMUser = (obj) => {
    const userExists = dmUser.some((user) => user.id === obj.id);
    if (!userExists) {
      setDMUsers((prevUsers) => [...prevUsers, obj]);
      addChangeToStore({key: 'dmUser', value: [...dmUser, obj]});
    }
    setInputValueDMUser('');
  };

  const deleteDMUser = (id) => {
    const updatedUsers = dmUser.filter((user) => user.id !== id);
    setDMUsers(updatedUsers);
    addChangeToStore({key: 'dmUser', value: updatedUsers});
  };

  const addChannel = (obj) => {
    const userExists = channels.some((user) => user.id === obj.id);
    if (!userExists) {
      setChannels((prevUsers) => [...prevUsers, obj]);
      addChangeToStore({key: 'logChannels', value: [...channels, obj]});
    }
    setInputValueChannels('');
  };

  const deleteChannel = (id) => {
    const updatedUsers = channels.filter((user) => user.id !== id);
    setChannels(updatedUsers);
    addChangeToStore({key: 'logChannels', value: updatedUsers});
  };

  const [arrAdmin, setArrAdmin] = useState([
    {
      color: 'C44A4A',
      img: 'crown',
      name: 'www.github.com',
    },
    {
      color: 'D8833B',
      img: 'bot',
      name: 'www.slack.com',
    },
    {
      color: '5296D5',
      img: 'manager',
      name: 'www.google.com',
    },
  ]);
  const [arrUsers, setArrUsers] = useState([
    {
      color: '',
      img: 'meow',
      name: '# 💬｜chat-room',
    },
    {
      color: '',
      img: 'hecker',
      name: '# 🌠｜memes',
    },
    {
      color: '',
      img: 'koi',
      name: '# 🚧｜disclaimer',
    },
  ]);

  const addNewRoleAmdin = () => {
    const newRole = {
      name: inputValue,
      color: '',
      img: '',
    };
    setArrAdmin((prev) => [...prev, newRole]);
    setInputValue('');
  };

  const handleKeyPressAdmin = (e) => {
    if (inputValue && e.key === 'Enter') {
      addNewRoleAmdin();
    }
  };

  const deleteAdmin = (index) => {
    // Приклад видалення для arrAdmin
    setArrAdmin((prev) => prev.filter((_, idx) => idx !== index));
  };

  const addNewRoleUser = () => {
    const newRole = {
      name: inputValueUser,
      color: '',
      img: '',
    };
    setArrUsers((prev) => [...prev, newRole]);
    setInputValueUser('');
  };

  const handleKeyPressUser = (e) => {
    if (inputValueUser && e.key === 'Enter') {
      addNewRoleUser();
    }
  };

  const deleteUser = (index) => {
    // Приклад видалення для arrAdmin
    setArrUsers((prev) => prev.filter((_, idx) => idx !== index));
  };
  return (
    <div className="notification_tamplate_block_wrap">
      <div className="notification_tamplate_block_wrap_bg"></div>
      <img className="notification_tamplate_block_wrap_img" src="/img/Notifications.svg" alt="" />
      <h3>
        Notifications <label htmlFor="">PRO</label>
      </h3>
      <div className="notification_tamplate_block_item" style={{borderBottom: '1px solid #8D99A3'}}>
        <div className="notification_tamplate_block_item_toggler">
          <TogglerBody isOn={isAlerts} setIsOn={setIsAlerts} keyName={'sendLogs'} />
          <p>Send Advanced Alerts</p>
        </div>
      </div>

      <div className="status_block_item ">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">Severity Level:</p>
          <TipsTamplate
            title={'Severity Level'}
            label={''}
            text={
              '<p>Choose the types of alerts you receive based on their importance, allowing you to stay informed about the events that concern you most.</p>'
            }
            textSecond={'<p>Severity levels are derived directly from the server logs</p>'}
          />
        </div>
        <div className="notification_tamplate_block_chekbox_wrap">
          <input
            type="checkbox"
            name="lLevel"
            id="lLevelCheckbox"
            checked={lLevel}
            onChange={handleCheckboxChange}
          />
          <p className="notification_tamplate_block_chekbox_item_low">Low</p>
        </div>
        <div className="notification_tamplate_block_chekbox_wrap">
          <input
            type="checkbox"
            name="mLevel"
            id="mLevelCheckbox"
            checked={mLevel}
            onChange={handleCheckboxChange}
          />
          <p className="notification_tamplate_block_chekbox_item_medium">Medium</p>
        </div>
        <div className="notification_tamplate_block_chekbox_wrap">
          <input
            type="checkbox"
            name="hLevel"
            id="hLevelCheckbox"
            checked={hLevel}
            onChange={handleCheckboxChange}
          />
          <p className="notification_tamplate_block_chekbox_item_high">High</p>
        </div>
      </div>
      <div className="status_block_item ">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">Notification Channels:</p>
          <TipsTamplate
            title={'Notification Channels'}
            label={''}
            text={'<p>Designate where you`ll receive notifications. </p>'}
            textSecond={
              '<p>Choose the ways where you want to be informed about important events.</p>'
            }
          />
        </div>

        <div className="notification_tamplate_block_chekbox_wrap">
          <input
            type="checkbox"
            name="discordLogs"
            id="discordLogsCheckbox"
            checked={discordLogs}
            onChange={handleCheckboxChange}
          />
          <div className="notification_tamplate_block_chekbox_discod">
            {' '}
            <img src="/img/Dicord.svg" alt="" /> <p>Discord</p>
          </div>
        </div>
      </div>
      <div className="status_block_item ">
        <p className="status_block_item_title_solo">DM Users::</p>
        <div className="white_list_block_item_arr_user_wrap">
          {dmUser?.map((item, idx) => (
            <div key={idx} className="access_component_user_one white_list_block_user_one">
              {/* { item?.img &&
                                    <img src={`/img/user/${item?.img}.svg`} alt="" />
                                } */}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteDMUser(idx)}>
                <RxCross1 />
              </span>
            </div>
          ))}
          {showBtnUser ? (
            <SearchDropdownBtn setShowBtn={setShowBtnUser} />
          ) : (
            <SearchDropdown
              data={membersGlobalState?.data?.members}
              value={inputValueDMUser}
              setInputValue={setInputValueDMUser}
              setShowBtn={setShowBtnUser}
              handleSelectItem={addDMUser}
            />
          )}
        </div>
      </div>
      <div className="status_block_item ">
        <p className="status_block_item_title_solo">Channels:</p>
        <div className="white_list_block_item_arr_user_wrap">
          {channels.map((item, idx) => (
            <div key={idx} className="access_component_user_one white_list_block_user_one">
              {/* { item?.img &&
                                    <img src={`/img/user/${item?.img}.svg`} alt="" />
                                } */}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteChannel(idx)}>
                <RxCross1 />
              </span>
            </div>
          ))}
          {showBtnChannel ? (
            <SearchDropdownBtn setShowBtn={setShowBtnChannel} />
          ) : (
            <SearchDropdown
              data={channelsGlobalState?.data?.channels}
              value={inputValueChannels}
              setInputValue={setInputValueChannels}
              setShowBtn={setShowBtnChannel}
              handleSelectItem={addChannel}
            />
          )}
        </div>
      </div>
      <div className="status_block_item ">
        {/* <p className='status_block_item_title_solo'>Notification Channels:</p> */}
        <div className="notification_tamplate_block_chekbox_wrap">
          <input
            type="checkbox"
            name="emailLogs"
            id="emailLogsCheckbox"
            checked={emailLogs}
            onChange={handleCheckboxChange}
          />
          <div className="notification_tamplate_block_chekbox_discod">
            {' '}
            <img src="/img/Email.svg" alt="" /> <p>Mail</p>
          </div>
        </div>
      </div>
      <div className="status_block_item ">
        <p className="status_block_item_title_solo">Emails:</p>
        <div className="white_list_block_item_arr_user_wrap">
          {arrUsers.map((item, idx) => (
            <div key={idx} className="access_component_user_one white_list_block_user_one">
              {/* { item?.img &&
                                    <img src={`/img/user/${item?.img}.svg`} alt="" />
                                } */}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteUser(idx)}>
                <RxCross1 />
              </span>
            </div>
          ))}
          <input
            type="text"
            placeholder="..."
            value={inputValueUser}
            onChange={(e) => {
              setInputValueUser(e.target.value);
            }}
            onKeyPress={handleKeyPressUser}
          />
        </div>
      </div>
      {/* <div className='notification_tamplate_block_item_img_plug_wrap'>
                <div className='notification_tamplate_block_item_img_plug'>
                    <img src="/img/plugSubcribe.png" alt="" />
                </div>
            </div> */}
    </div>
  );
};

export default NotificationTamplateBlock;
